import { z } from 'zod';
import { idSchema, isoTimestampSchema } from '../domain/primitives.js';
export const presenceStatusSchema = z.enum(['online', 'away', 'offline']);
/**
 * What a client emits on `presence.update` to report its own status.
 *
 * A client may only set its own presence: the server derives the user from the
 * authenticated socket and ignores any identity claimed in a payload.
 */
export const presenceUpdateInputSchema = z.object({
    status: presenceStatusSchema,
});
/** What the server broadcasts on `presence.update` when someone's status changes. */
export const presenceUpdateSchema = z.object({
    userId: idSchema,
    status: presenceStatusSchema,
    /** When the server last observed activity from this user. */
    lastSeenAt: isoTimestampSchema,
});
//# sourceMappingURL=presence.js.map